export default {
  init() {

  },
  finalize() {
    const $nav = $('.navigation-mobile');

    // Set the height
    $nav.find('.mobile-nav-inner').css({ height: $nav.find('.nav-screen.nav-screen-1').outerHeight() });

    // Click a first level item with children
    $nav.find('.menu-item.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Remove all the children
      $nav.find('.nav-screen.nav-screen-2 .nav-screen-items').children().remove();

      // Populate the second level screen with the children
      $(this).siblings('.sub-menu').find('> .menu-item').each(function() {
        const $navItem = $(this).clone();
        $navItem.appendTo($nav.find('.nav-screen.nav-screen-2 .nav-screen-items'));
      });

      // Set the back button
      const menuLabel = $(this).html();
      $nav.find('.nav-screen-2-return').html(menuLabel);

      // Set the height
      $nav.find('.mobile-nav-inner').css({ height: $nav.find('.nav-screen.nav-screen-2').outerHeight() });

      // Switch
      $nav.find('.mobile-nav-inner').addClass('screen-2');
    });

    // Go back to first level
    $nav.find('.nav-screen-2-return').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $nav.find('.mobile-nav-inner').removeClass('screen-2');

      // Set the height
      $nav.find('.mobile-nav-inner').css({ height: $nav.find('.nav-screen.nav-screen-1').outerHeight() });
    });

    // Open/Close nav
    $nav.find('.mobile-nav-burger-open').on('click', function() {
      if ($nav.find('.mobile-nav-wrap').hasClass('open')) {
        $nav.find('.mobile-nav-wrap').removeClass('open');
        $nav.find('.mobile-nav-inner').removeClass('screen-2');

        // Set the height
        $nav.find('.mobile-nav-inner').css({ height: $nav.find('.nav-screen.nav-screen-1').outerHeight() });
      } else {
        $nav.find('.mobile-nav-wrap').addClass('open');
      }
    });

    // Apple ios redraw bug hack
    $nav.find('.mobile-nav-inner').css('display', 'flex');
    $nav.find('.mobile-nav-inner')[0].offsetHeight;
    $nav.find('.mobile-nav-inner').css('display', 'block');
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigationMobile.js